import cloneDeep from "lodash/cloneDeep";
import set from "lodash/set";
import { formatFilterV2ToApiFormat } from "PFApp/components/filters_v2";
import { buildOriginalFilterPath } from "PFCore/helpers/filters";
import { Id } from "PFTypes";
import { ApiFilterGroupV2, FiltersV2, KnownFiltersV2 } from "PFTypes/filters_v2";

import { PER_PAGE, RequestData } from "./get_request_data";

export const getEngagementChildRolesRequest = (id: Id, rolesFilters: FiltersV2 = {}): RequestData => {
  const filters = formatFilterV2ToApiFormat(cloneDeep(rolesFilters));
  set(filters, buildOriginalFilterPath(ApiFilterGroupV2.Fields, KnownFiltersV2.ParentActivityId), id);

  return {
    url: "booking_module/nested_activities/index",
    options: {
      method: "POST",
      stringify: true,
      contentType: "application/json; charset=utf-8"
    },
    data: {
      perPage: PER_PAGE,
      filters,
      order: {
        name: ["activity.saas_created_at"],
        text: "Latest first",
        direction: "desc"
      }
    },
    childrenType: "role"
  };
};
